import React from 'react';

function Bone({ className = '', style }) {
  return (
    <div
      className={`bg-gray-200 rounded animate-pulse ${className}`}
      style={style}
    />
  );
}

export function SkeletonAdminList({ rows = 6, showHeader = true }) {
  return (
    <div>
      {showHeader && (
        <div className="flex items-center justify-between mb-6">
          <div>
            <Bone className="h-8 w-32 mb-2" />
            <Bone className="h-4 w-56" />
          </div>
          <Bone className="h-9 w-36 rounded-lg" />
        </div>
      )}
      <div className="bg-white rounded-xl border border-[#E6E6E6]">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className={`flex items-center justify-between px-5 py-3.5 ${i !== rows - 1 ? 'border-b border-[#E6E6E6]' : ''}`}>
            <div className="flex items-center gap-4 flex-1">
              <Bone className="w-9 h-9 rounded-full" />
              <Bone className="h-4 w-32" />
              <Bone className="h-4 w-48 hidden md:block" />
            </div>
            <Bone className="h-8 w-20 rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonAdminDetail() {
  return (
    <div>
      <Bone className="h-4 w-16 mb-4" />
      <Bone className="h-8 w-64 mb-2" />
      <Bone className="h-4 w-40 mb-6" />
      <div className="bg-white rounded-xl border border-[#E6E6E6] p-6 mb-6">
        <Bone className="h-4 w-32 mb-3" />
        <Bone className="h-9 w-full rounded-lg" />
      </div>
      <Bone className="h-5 w-24 mb-3" />
      <div className="bg-white rounded-xl border border-[#E6E6E6]">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className={`flex items-center justify-between px-5 py-3.5 ${i !== 2 ? 'border-b border-[#E6E6E6]' : ''}`}>
            <Bone className="h-4 w-40" />
            <Bone className="h-5 w-5 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonAdminSettings() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <Bone className="h-8 w-40" />
        <Bone className="h-9 w-32 rounded-lg" />
      </div>
      <div className="bg-white rounded-xl border border-[#E6E6E6] p-6 mb-6">
        <Bone className="h-5 w-24 mb-4" />
        <Bone className="h-9 w-full rounded-lg" />
      </div>
      <div className="bg-white rounded-xl border border-[#E6E6E6] p-6 mb-6">
        <Bone className="h-5 w-24 mb-4" />
        <div className="flex gap-6">
          <Bone className="h-20 flex-1 rounded-lg" />
          <Bone className="h-20 flex-1 rounded-lg" />
        </div>
      </div>
      <div className="bg-white rounded-xl border border-[#E6E6E6] p-6">
        <Bone className="h-5 w-32 mb-4" />
        <div className="grid grid-cols-3 gap-6">
          <Bone className="h-9 rounded-lg" />
          <Bone className="h-9 rounded-lg" />
          <Bone className="h-9 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

